export default {
  "b2b.zadosti-odbaveni-widget.label": "Request processing",
  "b2b.zadosti-odbaveni-widget.message-empty": "No requests to process."
};
